// extracted by mini-css-extract-plugin
export default {"countDown":"countdown_countDown__yivhj"};